import React from 'react';
import { View, ScrollView, StyleSheet, ActivityIndicator } from 'react-native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { useTranslation } from 'react-i18next';
import { RootStackParamList } from '../types';
import { AppHeader, EditProfileForm, ScreenLayout, PageTitle } from '../components';
import { Colors, Spacing } from '../constants';
import { useUser } from '../contexts';
import { useResponsive } from '../utils/responsive';

type Props = NativeStackScreenProps<RootStackParamList, 'EditProfile'>;

export const EditProfileScreen: React.FC<Props> = ({ navigation }) => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { isDesktop } = useResponsive();

  if (!user) {
    return (
      <ScreenLayout>
        <View style={styles.loading}>
          <ActivityIndicator color={Colors.primary} />
        </View>
      </ScreenLayout>
    );
  }

  return (
    <ScreenLayout maxWidth={600} desktopPadding>
      <View style={styles.container}>
        {!isDesktop && (
          <AppHeader
            navigation={navigation}
            currentScreen="Profile"
            title={t('screens.profile.editProfileTitle')}
            showBackButton
          />
        )}
        <ScrollView contentContainerStyle={[styles.scrollContent, isDesktop && styles.scrollContentDesktop]} keyboardShouldPersistTaps="handled">
          {isDesktop && <PageTitle title={t('screens.profile.editProfileTitle')} onBack={() => navigation.goBack()} />}
          <EditProfileForm
            user={user}
            onSave={() => navigation.goBack()}
            onCancel={() => navigation.goBack()}
            showTitle={false}
          />
        </ScrollView>
      </View>
    </ScreenLayout>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  scrollContent: {
    padding: Spacing.base,
    paddingBottom: Spacing['3xl'],
  },
  scrollContentDesktop: {
    padding: 0,
  },
  loading: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
